module.exports = __webpack_public_path__ + "img/es_Ecran 6.00ea2975.png";